import { useState, useEffect } from "react";
import { supabase } from "./supabase";

const NIVELES = ['Primario incompleto','Primario completo','Secundario incompleto','Secundario completo','Terciario','Universitario','Posgrado'];

export default function PerfilesPuesto({ oscuro, usuario, embebido }) {
  const [lista, setLista] = useState([]);
  const [form, setForm] = useState({ puesto:"", area:"", edadMin:18, nivelMin:"", expMin:0, competencias:"", responsabilidades:"" });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(true);
  const esAdmin = usuario?.rol === "Administrador" || usuario?.rol === "RecursosHumanos";

  const C = { bg:oscuro?"#0a1129":"#F0EEFF", card:oscuro?"#0f1c3f":"#fff", navy:"#09184D", purple:"#7B5BF2", green:"#22c55e", amber:"#f59e0b", sub:"#808085", border:oscuro?"#1e3a8a":"#dde3f0", text:oscuro?"#EDF2FA":"#2F3E2E" };
  const inp = { width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"13px", boxSizing:"border-box", marginTop:"6px", background:oscuro?"#0a1129":"white", color:C.text };
  const lbl = { fontSize:"11px", color:C.sub, fontWeight:"700", display:"block", marginTop:"12px", textTransform:"uppercase" };
  const card = { background:C.card, borderRadius:"14px", padding:"1.2rem", border:`1.5px solid ${C.border}`, marginBottom:"12px" };

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setLoading(true);
    try { const { data } = await supabase.from("perfiles_puesto").select("data").order("id", { ascending:false }); setLista(data ? data.map(r => r.data) : []); }
    catch(e) { console.warn(e); }
    setLoading(false);
  };

  const guardar = async () => {
    if (!form.puesto.trim()) { alert("Poné el nombre del puesto."); return; }
    const p = { ...form, id: editId || Date.now(), creado_por: usuario?.nombre, actualizado_at: new Date().toISOString() };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("perfiles_puesto").upsert([{ id:p.id, data:p, tenant_id:tenantId }]); } catch(e) { console.warn(e); }
    setForm({ puesto:"", area:"", edadMin:18, nivelMin:"", expMin:0, competencias:"", responsabilidades:"" });
    setEditId(null); await cargar();
  };

  const editar = (p) => { setForm(p); setEditId(p.id); window.scrollTo(0,0); };

  return (
    <div style={{ minHeight: embebido?"auto":"100vh", background: embebido?"transparent":C.bg, fontFamily:"sans-serif" }}>
      <div style={{ padding:"1.5rem", maxWidth:"700px", margin:"0 auto" }}>
        {esAdmin && (
          <div style={card}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.purple, marginBottom:"4px" }}>{editId ? "Editar perfil" : "Nuevo perfil de puesto"}</h3>
            <span style={lbl}>Puesto / Cargo</span>
            <input value={form.puesto} onChange={e=>setForm(f=>({...f,puesto:e.target.value}))} style={inp} placeholder="Ej: Operario de impresión"/>
            <span style={lbl}>Área</span>
            <input value={form.area} onChange={e=>setForm(f=>({...f,area:e.target.value}))} style={inp} placeholder="Ej: Producción"/>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"10px" }}>
              <div><span style={lbl}>Edad mínima</span><input type="number" min="16" value={form.edadMin} onChange={e=>setForm(f=>({...f,edadMin:parseInt(e.target.value)||0}))} style={inp}/></div>
              <div><span style={lbl}>Experiencia mín. (años)</span><input type="number" min="0" value={form.expMin} onChange={e=>setForm(f=>({...f,expMin:parseInt(e.target.value)||0}))} style={inp}/></div>
            </div>
            <span style={lbl}>Nivel de estudios mínimo</span>
            <select value={form.nivelMin} onChange={e=>setForm(f=>({...f,nivelMin:e.target.value}))} style={inp}>
              <option value="">Sin requisito</option>
              {NIVELES.map(n=><option key={n}>{n}</option>)}
            </select>
            <span style={lbl}>Competencias requeridas</span>
            <textarea rows={2} value={form.competencias} onChange={e=>setForm(f=>({...f,competencias:e.target.value}))} style={{...inp, resize:"vertical"}} placeholder="Ej: manejo de offset, lectura de OT"/>
            <span style={lbl}>Responsabilidades</span>
            <textarea rows={2} value={form.responsabilidades} onChange={e=>setForm(f=>({...f,responsabilidades:e.target.value}))} style={{...inp, resize:"vertical"}}/>
            <button onClick={guardar} style={{ width:"100%", marginTop:"16px", padding:"11px", background:C.purple, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"14px", fontWeight:"700" }}>{editId ? "💾 Actualizar" : "+ Crear perfil"}</button>
            {editId && <button onClick={()=>{ setForm({ puesto:"", area:"", edadMin:18, nivelMin:"", expMin:0, competencias:"", responsabilidades:"" }); setEditId(null); }} style={{ width:"100%", marginTop:"8px", padding:"9px", background:"white", color:C.sub, border:`1.5px solid ${C.border}`, borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>Cancelar edición</button>}
          </div>
        )}
        <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.sub, margin:"20px 0 12px", textTransform:"uppercase" }}>Perfiles definidos</h3>
        {loading && <p style={{ color:C.sub, textAlign:"center" }}>⏳ Cargando...</p>}
        {!loading && lista.length===0 && <p style={{ color:C.sub, textAlign:"center", padding:"2rem" }}>Sin perfiles</p>}
        {lista.map(p => (
          <div key={p.id} style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <div>
                <p style={{ fontSize:"14px", fontWeight:"700", color:C.navy, margin:"0 0 2px" }}>{p.puesto}</p>
                <p style={{ fontSize:"11px", color:C.sub, margin:0 }}>{p.area}</p>
              </div>
              {esAdmin && <button onClick={()=>editar(p)} style={{ fontSize:"11px", background:"#eff6ff", color:"#2A7FFF", border:"none", borderRadius:"8px", padding:"5px 10px", cursor:"pointer", fontWeight:"600" }}>✏️ Editar</button>}
            </div>
            <div style={{ marginTop:"10px", fontSize:"12px", color:C.text, display:"flex", flexWrap:"wrap", gap:"6px" }}>
              <span style={{ background:"#f0fdf4", padding:"3px 8px", borderRadius:"6px" }}>👤 +{p.edadMin} años</span>
              {p.nivelMin && <span style={{ background:"#f5f3ff", padding:"3px 8px", borderRadius:"6px" }}>🎓 {p.nivelMin}</span>}
              <span style={{ background:"#fffbeb", padding:"3px 8px", borderRadius:"6px" }}>💼 {p.expMin} años exp.</span>
            </div>
            {p.competencias && <p style={{ fontSize:"12px", color:C.sub, margin:"8px 0 0" }}><b>Competencias:</b> {p.competencias}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
